import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@app/_services/settings.service';

@Pipe({
    name: 'parseRemainingDays',
    standalone: true
})

export class ParseRemainingDaysPipe implements PipeTransform {
    constructor(private ss: SettingsService) { }
    transform(value: number | null): string {
        if (!value) return '';
        return value === 1 ? this.ss.texts()['actionCommon_endingToday'] : value === 2 ? this.ss.texts()['actionCommon_endingIn1DayAlert'] : this.ss.interpolateText('actionCommon_endingInDaysAlert', { numberOfDays: (value - 1).toString() });
    }
}